// Products sold by KG/KGS always default to the Master Catalogue outward selling price
// (batch / margin-slab pricing is skipped). Mirrors backend services/catalogue_pricing.py.
const KG_UNITS = ['KG', 'KGS', 'KILOGRAM', 'KILOGRAMS'];

export function isCataloguePriced(product) {
  if (!product) return false;
  const unit = String(product.unit || product.measurement_unit || '').trim().toUpperCase();
  return KG_UNITS.includes(unit);
}

export function cataloguePrice(product) {
  const p = parseFloat(product && product.outward_selling_price);
  return isCataloguePriced(product) && p > 0 ? p : null;
}
